import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Subscription } from 'rxjs/Subscription';
import { AuthService } from '../../services/shared/auth.service';
import { LogService } from '../../services/shared/log.service';
import { NGaugeService } from '../../services/shared/ngauge.service';
import { TechService } from '../../services/tech.service';
import { UserService } from '../../services/user.service';
import { CLUSTER_ARRAY, LOGGED_IN_PROPERTY, LOG_LEVELS, USER_INFO } from '../../util/constants';

@Component({
  selector: 'app-switch-property',
  templateUrl: './switch-property.component.html',
  styleUrls: ['./switch-property.component.scss']
})

export class SwitchPropertyComponent implements OnInit, OnDestroy {

  isMultiProperty: boolean;
  selected: any;
  buttonClicked = false;
  userPassword = '';
  invalidCredentials = false;
  userEmail: any;
  isLoading = false;
  show = false;
  filteredProperty: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  propertyFilterCtrl: FormControl = new FormControl();
  filteredClusterProperty: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  clusterPropertyFilterCtrl: FormControl = new FormControl();
  loginSubscription: Subscription;
  getUserSubscription: Subscription;
  getPropertySubscription: Subscription;
  clusterProperty = false;
  selectedClusterProperty = '';

  constructor(
    public dialogRef: MatDialogRef<SwitchPropertyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService,
    private authService: AuthService,
    private logService: LogService,
    private ngaugeService: NGaugeService,
    private techService: TechService) {
    this.userEmail = this.userService.getLoggedInEmail();
    const currentProperty = ngaugeService.isJSON(this.userService.getLoggedInUserProperty());
    data.propertyList = this.ngaugeService.removeDuplicatesArrOfString(data.propertyList);
    data.propertyList = data.propertyList.filter(property => property !== currentProperty);
    this.ngaugeService.buildFilter(this.propertyFilterCtrl, this.filteredProperty, data.propertyList, '');
    this.checkForClusterProperty();
  }

  ngOnInit() {
    if (this.data.propertyList.length === 1) {
      this.isMultiProperty = false;
      this.selected = this.data.propertyList[0];
      this.showClusterPropertyList(this.selected);
    } else {
      this.isMultiProperty = true;
    }
  }

  checkForClusterProperty() {
    const clusterProperties = this.ngaugeService.isJSON(sessionStorage.getItem(CLUSTER_ARRAY));
    const isClusterproperty = this.ngaugeService.getIsClusterProperty();
    if (isClusterproperty) {
      const loggedInProperty = this.userService.getLoggedInUserProperty();
      clusterProperties.forEach(cluster => {
        if (cluster.permissionProperty.includes(loggedInProperty)) {
          if (cluster.permissionProperty.length === 1) {
            const findProperty = this.data.propertyList.findIndex(prop => prop === cluster.name);
            this.data.propertyList.splice(findProperty, 1);
            this.ngaugeService.buildFilter(this.propertyFilterCtrl, this.filteredProperty, this.data.propertyList, '');
          }
        }
      });
    }
  }

  toggleShow() {
    this.show = !this.show;
    this.logService.logUserActivity(LOG_LEVELS.INFO, 'Login', 'View password');
  }

  showClusterPropertyList(selectedProperty) {
    const properties = this.ngaugeService.isJSON(sessionStorage.getItem(CLUSTER_ARRAY));
    const loggedInProperty = this.userService.getLoggedInUserProperty();
    const findClusterArray = properties.find(property => property.name === selectedProperty);
    if (findClusterArray) {
      this.clusterProperty = true;
      this.isMultiProperty = true;
      this.selectedClusterProperty = '';
      let clusterProperties = findClusterArray.permissionProperty;
      clusterProperties = this.ngaugeService.removeDuplicatesArrOfString(clusterProperties);
      clusterProperties = clusterProperties.filter(property => property !== loggedInProperty);
      this.ngaugeService.buildFilter(this.clusterPropertyFilterCtrl, this.filteredClusterProperty, clusterProperties, '');
      if (clusterProperties.length === 1) {
        this.selectedClusterProperty = clusterProperties[0];
      }
    } else {
      this.clusterProperty = false;
    }
  }

  onClickConfirm() {
    if (this.buttonClicked === false) {
      this.isLoading = true;
      this.buttonClicked = true;
      this.selected = this.clusterProperty === false ? this.selected : this.selectedClusterProperty;
      sessionStorage.setItem(LOGGED_IN_PROPERTY, this.selected);
      const values = { email: this.userService.getLoggedInUser(), accessToken: this.userService.getAccessToken(), property: this.selected };
      this.logService.logUserActivity(LOG_LEVELS.INFO, 'Switch Property', this.selected);
      this.logService.logUserActivity(LOG_LEVELS.INFO, 'Switch Property', 'Switch!');
      this.loginSubscription = this.authService.switch(values).subscribe(response => {
        if (response['id'] !== undefined) {
          this.invalidCredentials = false;
          this.techService.publishCloseSideNavTriggerer('close');
          this.getUserSubscription = this.authService.getUserById(response['id'], response['accessToken']).subscribe(() => {

            const userInfo = this.userService.getSessionStorage();
            this.getPropertySubscription = this.authService.getPropertyLogo(this.selected).subscribe(details => {
              userInfo['propertyType'] = details[0]['type'];
              userInfo['propertyLogo'] = details[0] !== undefined ? details[0]['image'] : null;
              sessionStorage.setItem(USER_INFO, JSON.stringify(userInfo));
              this.authService.clearLocalVariables();
              this.userService.userUpdateDone('update');
              const url = this.ngaugeService.getCurrentUrl();
              if (url.includes('dashboard')) {
                this.userService.userDashboardUpdateDone('update');
                this.dialogRef.close();
              } else {
                this.ngaugeService.routeTo('/dashboard');
                this.dialogRef.close();
              }
            }, error => {
              console.log('ERROR 138', error);
              this.ngaugeService.routeTo('/dashboard');
              this.dialogRef.close();
            });
          }, error => {
            this.getUserSubscription = this.authService.getUserByIdAndProperty(response["id"], response["accessToken"], this.selected)
            .subscribe(() => {
              const userInfo = this.userService.getSessionStorage();
              this.getPropertySubscription = this.authService.getPropertyLogo(this.selected).subscribe(details => {
                userInfo['propertyType'] = details[0]['type'];
                userInfo['propertyLogo'] = details[0] !== undefined ? details[0]['image'] : null;
                sessionStorage.setItem(USER_INFO, JSON.stringify(userInfo));
                this.authService.clearLocalVariables();
                this.userService.userUpdateDone('update');
                const url = this.ngaugeService.getCurrentUrl();
                if (url.includes('dashboard')) {
                  this.userService.userDashboardUpdateDone('update');
                  this.dialogRef.close();
                } else {
                  this.ngaugeService.routeTo('/dashboard');
                  this.dialogRef.close();
                }
              }, error => {
                console.log('ERROR 138', error);
                this.ngaugeService.routeTo('/dashboard');
                this.dialogRef.close();
              });
            }, error => {
              console.log('ERROR 167', error);
              this.ngaugeService.routeTo('/dashboard');
              this.dialogRef.close();
            });
          });
        } else {
          this.isLoading = false;
          this.buttonClicked = false;
          this.invalidCredentials = true;
        }
      }, error => {
        console.log('ERROR 150');
        this.isLoading = false;
        this.buttonClicked = false;
        this.invalidCredentials = true;
        this.logService.logError(LOG_LEVELS.ERROR, 'On Switch Property Component', 'On try For Login', JSON.stringify(error));
      });
    }
  }

  onClickCancel() {
    this.logService.logUserActivity(LOG_LEVELS.INFO, 'Switch Property', this.selected);
    this.logService.logUserActivity(LOG_LEVELS.INFO, 'Switch Property', 'Cancel');
    this.dialogRef.close();
  }

  logout() {
    this.logService.logUserActivity(LOG_LEVELS.INFO, 'Switch Property', 'Sign Out');
    this.dialogRef.close();
    this.authService.logout();
  }

  unSubscribe(subscription: Subscription) {
    if (this.ngaugeService.checkForNllUndef(subscription)) {
      subscription.unsubscribe();
    }
  }

  ngOnDestroy() {
    this.unSubscribe(this.loginSubscription);
    this.unSubscribe(this.getUserSubscription);
    this.unSubscribe(this.getPropertySubscription);
    this.isMultiProperty = null;
    this.selected = null;
    this.buttonClicked = null;
    this.userPassword = null;
    this.invalidCredentials = null;
    this.userEmail = null;
    this.isLoading = null;
    this.show = null;
    this.filteredProperty = null;
    this.propertyFilterCtrl = null;
    this.dialogRef = null;
    this.data = null;
    this.userService = null;
    this.authService = null;
    this.logService = null;
    this.ngaugeService = null;
    this.techService = null;
    this.clusterProperty = null;
    this.selectedClusterProperty = null;
    this.clusterPropertyFilterCtrl = null;
    this.filteredClusterProperty = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/switch-property/switch-property.component.ts